import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export function NewFeatureBadge({
  className
}) {
  return /*#__PURE__*/_jsx(UITooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "composer-ui.pop-out.badge.introduction"
    }),
    children: /*#__PURE__*/_jsx(UIBadge, {
      use: "new",
      className: className,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "composer-ui.pop-out.badge.new"
      })
    })
  });
}
NewFeatureBadge.displayName = 'FullscreenComposerButtonFeatureBadge';